import {Link, useSearchParams} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import AxiosConfig from "../../../services/AxiosConfig";
import styles from "../../../pages/Admin/Admin.module.css";
import styles_modal from "../../Modal/Modal.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAddressCard, faArrowLeftRotate,
    faBuilding,
    faDownload,
    faEdit, faExternalLink, faSquareCheck, faUserPlus,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {exportToCsv, generateCsv, handleSubmitCsvUsers} from "../../../services/FileService";
import {Field, Form, Formik} from "formik";
import UtilisateursTable from "../Utilisateurs/UtilisateursTable";
import {getUtilisateurs} from "../../../services/UserService";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import {fetchGetContrats, fetchToSetContratActif} from "../../../services/EntrepriseService";
import ContratsTable from "../Contrat/ContratsTable";
import TitleMain from "../../Title/TitleMain";
import BtnCopy from "../../Button/BtnCopy";
import {ImageIllustrationUpload} from "../../Image/ImageIllustrationUpload";
import Routing from "../../../services/routing";
import DateService from "../../../services/DateService";

function EntrepriseVue({mode = "consultation", entreprise}) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [data, setData] = useState(entreprise);
    const [afficherContrats, setAfficherContrats] = useState(false);
    const [afficherSalaries, setAfficherSalaries] = useState(false);
    const [afficherReferents, setAfficherReferents] = useState(false);
    const [afficherSeances, setAfficherSeances] = useState(false);
    const [salaries, setSalaries] = useState([]);
    const [referents, setReferents] = useState([]);
    const [contrats, setContrats] = useState([]);
    const [lienEnrolement, setLienEnrolement] = useState(entreprise?.enrolementLink?.url || "");
    const fileInputRef = useRef(null);

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const toggleContrats = async () => {
        const response = await fetchGetContrats(data.id);
        if (response.success) {
            setContrats(response.data);
            setAfficherContrats(!afficherContrats);
            setAfficherSalaries(false);
            setAfficherReferents(false);
            setAfficherSeances(false);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const toggleSalaries = async () => {
        const response = await getUtilisateurs({entreprise: data.id}, "/admin/utilisateurs");
        if (response.success) {
            setSalaries(response.myUtilisateurs);
            setAfficherReferents(false);
            setAfficherSalaries(true);
            setAfficherContrats(false);
            setAfficherSeances(false);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const downloadSalaries = async () => {
        const response = await getUtilisateurs({entreprise: data.id}, "/admin/utilisateurs_csv");
        if (response.success) {
            // Formater response.myUtilisateurs json en csv puis telecharger un csv de response.myUtilisateurs
            exportToCsv("salaries", response.myUtilisateurs);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const toggleReferents = async () => {
        const response = await getUtilisateurs({entreprise: data.id, role: "ROLE_REFERENT"}, "/admin/utilisateurs");
        if (response.success) {
            setReferents(response.myUtilisateurs);
            setAfficherSalaries(false);
            setAfficherReferents(true);
            setAfficherContrats(false);
            setAfficherSeances(false);
        } else {
            console.error("error", response);
            handleError(response.message);
        }
    };

    const toggleSeances = () => {
        setAfficherSeances(!afficherSeances);
        setAfficherSalaries(false);
        setAfficherContrats(false);
        setAfficherReferents(false);
    };

    const regenerateEnrolement = async () => {
        showModal('confirm', {
            message: "Cette action désactivera tous les précédents liens d'enrolement de cette entreprise. Continuer ?",
            onConfirm: async () => {
                try {
                    const response = await AxiosConfig.post(`/admin/entreprises/${data.id}/generate_enrolement`);
                    handleSuccess("Lien généré avec succès");
                    setLienEnrolement(process.env.REACT_APP_URL_FRONT + response.data.enrolementLink.url);
                } catch (error) {
                    console.error('error', error);
                    handleError();
                }
            }
        });
    }

    const setEntrepriseActif = async (actif) => {
        try {
            const response = await AxiosConfig.post(`/admin/entreprises/${data.id}/actif`, {"actif": actif});
            setData(response.data.myEntreprise);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putActifOpenModal = () => {
        const text = data.actif ? "supprimer" : "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} cette entreprise ?`,
            onConfirm: () => {
                setEntrepriseActif(!data.actif);
                handleSuccess("Enregistré");
            }
        });
    }

    const putActifOpenModalUtilisateur = (utilisateur) => {

    }

    const putActifOpenModalContrat = (contrat) => {
        const text = contrat.actif ? "supprimer" : "activer";
        showModal('confirm', {
            message: `Voulez-vous vraiment ${text} ce contrat ?`,
            onConfirm: async () => {
                const response = await fetchToSetContratActif(contrat);
                if (response.success) {
                    handleSuccess(response.message);
                } else {
                    handleError(response.message);
                }
                setTimeout(async () => {
                    const response = await fetchGetContrats(data.id);
                    if (response.success) {
                        setContrats(response.data);
                    } else {
                        console.error("error", response);
                        handleError(response.message);
                    }
                }, 500);
            }
        });
    }

    const handleSubmitCsvUserss = async (values, overwrite = false) => {
        const response = await handleSubmitCsvUsers(values, entreprise.id, overwrite);
        if (response.success) {
            handleSuccess(`${response.msg} - ${response.nbUtilisateursImportes} utilisateur(s) importé(s)`);
        } else {
            handleError(response.msg);
        }
    }

    const handleSubmitCsvUsersPrep = async (values) => {
        showModal('classic', {
            children:
                <div style={{padding: "20px"}}>
                    <h3 className={"titleAlert"}>En cas de mail déjà existant ?</h3>
                    <div className={styles_modal.btnChoiceBar}>
                        <button className="btn btn_main" onClick={() => handleSubmitCsvUserss(values, true)}>Mettre à jour l'utilisateur</button>
                        <button className="btn btn_main" onClick={() => handleSubmitCsvUserss(values, false)}>Ignorer l'utilisateur</button>
                    </div>
                </div>
    });
    }

    const handleSubmitUtilisateurStatus = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/utilisateurs/${values.id}/status`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
                if (afficherReferents === true) {
                    toggleReferents();
                }
                if (afficherSalaries === true) {
                    toggleSalaries();
                }
            } else {
                console.error('error', response.data);
                handleError("Erreur : " + response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    };

    useEffect(() => {
        if (!entreprise || !entreprise.id) {
            return;
        }

        setData(entreprise);
        setLienEnrolement(process.env.REACT_APP_URL_FRONT + entreprise.enrolementLink.url);
    }, [user, entreprise]);

    if (!data || !data.id) {
        return <p>Chargement ...</p>;
    }


    const handleSubmitLogo = async (values, {setSubmitting, resetForm, setErrors}) => {
        if (values.file) {
            const formData = new FormData();
            formData.append("file", values.file);

            try {
                const response = await AxiosConfig.post(`/admin/entreprises/${entreprise.id}/logo`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.data.success) {
                    handleSuccess("Logo enregistré avec succès");
                    setData(prevState => ({
                        ...prevState,
                        logo: `${response.data.entreprise}?t=${new Date().getTime()}`
                    }));
                } else {
                    handleError("Logo non enregistré suite à une erreur.");
                }
                resetForm();
            } catch (error) {
                console.error("Erreur lors de l'upload du fichier", error);
            }
        } else {
            setErrors({file: "Un fichier est requis"});
        }

        setSubmitting(false);
    };

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    return (
        <>
            <div className="content">
                <TitleMain text={data.nom}/>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                    <div style={{display: "flex", flexDirection: "column", gap: "10px", width: "719px"}}
                         className={styles.viewBloc}>
                        <div className={styles.headerBtnsVue}>
                            <button onClick={putActifOpenModal}>{data.actif ? <><FontAwesomeIcon
                                icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                                icon={faSquareCheck}/>Restaurer</>}</button>
                            <Link to={Routing.routes.adminCreation}><FontAwesomeIcon
                                icon={faEdit}/>Modifier</Link>
                        </div>

                        <p className={styles.creerParLeBloc}>
                            Créé par<Link to={Routing.generate({ route: Routing.routes.adminUtilisateur, params: { utilisateurId: data.createdBy?.id} })}
                                          style={{margin: "0 2px"}}>{data.createdBy?.prenom} {data.createdBy?.nom}</Link>
                            le {DateService.formatDate(data.created)}
                            {data.updatedBy ? <> et mis à jour par<Link to={Routing.generate({ route: Routing.routes.adminUtilisateur, params: {utilisateurId: data.updatedBy?.id} })}
                                                                        style={{margin: "0 2px"}}>{data.updatedBy?.prenom} {data.updatedBy?.nom}</Link>
                                le {DateService.formatDate(data.updated)}</> : null}</p>

                        <div style={{display: "flex", flexDirection: "row", gap: "10px", marginBottom: "15px"}}>
                            <ImageIllustrationUpload src={data.logo} alt={data.nom} onClick={handleClick}/>
                            <Formik
                                initialValues={{file: null}}
                                onSubmit={handleSubmitLogo}
                            >
                                {({setFieldValue, submitForm, isSubmitting, errors}) => (
                                    <Form style={{display: "flex", flexDirection: "column"}}>
                                        <input
                                            id="file"
                                            className={styles.inputFileLogo}
                                            name="file"
                                            type="file"
                                            style={{display: 'none'}}
                                            ref={fileInputRef}
                                            onChange={(event) => {
                                                setFieldValue("file", event.currentTarget.files[0]);
                                                submitForm();
                                            }}
                                        />
                                        {errors.file ? <div style={{color: 'red'}}>{errors.file}</div> : null}
                                    </Form>
                                )}
                            </Formik>

                            <div>
                                <p><FontAwesomeIcon icon={faAddressCard}/> {data.siret}</p>

                                <p style={{marginBottom: "10px"}}><FontAwesomeIcon
                                    icon={faBuilding}/>
                                    <a target={"_blank"}
                                       href={`https://www.google.com/maps/place/${
                                           encodeURI(data.addr + " " + data.ville + " " + data.cp + " " + data.pays)
                                       }`}> {data.addr}, {data.ville} {data.cp} - {data.pays}</a>
                                </p>

                                <p style={{
                                    margin: "32px 0",
                                }}>{data.description}</p>

                                <div style={{
                                    outline: "1px solid var(--clr-accent)",
                                    backgroundColor: "var(--clr-bg)",
                                    padding: "6px",
                                    borderRadius: "6px"
                                }}>
                                    <FontAwesomeIcon icon={faUserPlus}/> Enrolement :
                                    <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "4px"}}>
                                        <Link to={data.enrolementLink.url}
                                              style={{display: "flex"}}><span style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            maxWidth: "100%",
                                            overflowWrap: "anywhere",
                                            fontSize: "0.75em",
                                            margin: "8px"
                                        }}>{lienEnrolement}</span></Link>
                                        <BtnCopy copy={lienEnrolement}/>
                                        <button className={`btn_pastille_accent`} onClick={regenerateEnrolement}
                                                title={"Re-générer un lien"}><FontAwesomeIcon icon={faArrowLeftRotate}/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.navLink}>
                            <Link to={Routing.generate({ route: Routing.routes.adminContrats, params: { entrepriseId: data.id } })}>
                                <FontAwesomeIcon icon={faExternalLink}/>
                                Accéder aux contrats
                            </Link>
                            <Link to={Routing.generate({ route: Routing.routes.adminEntrepriseSalaries, params: { entrepriseId: data.id } })}>
                                <FontAwesomeIcon icon={faExternalLink}/>
                                Accéder aux salariés
                            </Link>
                            <Link to={Routing.generate({ route: Routing.routes.adminUtilisateurs, queryParams: { mode: "creation_en_masse_csv", entreprise: data.id } })}>
                                <AjouterIcone/>
                                Ajouter des salariés depuis un fichier csv
                            </Link>
                            <Link to={Routing.generate({ route: Routing.routes.adminUtilisateurs, queryParams: { mode: "creation", entreprise: data.id } })}>
                                <AjouterIcone/>
                                Ajouter un salarié
                            </Link>
                            <Link to={Routing.generate({ route: Routing.routes.adminContrats, params: { entrepriseId: data.id }, queryParams: { mode: "creation" } })}>
                                <AjouterIcone/>
                                Ajouter un contrat
                            </Link>

                        </div>
                        <div className={styles.navLink} style={{display: "flex", gap: "10px", margin: "16px 0"}}>
                            <button className={"btn"} onClick={toggleContrats}>Afficher les contrats</button>
                            <button className={"btn"} onClick={toggleSalaries}>Afficher les salariés</button>
                            <button className={"btn"} onClick={toggleReferents}>Afficher les référents</button>
                            <button className={"btn"} onClick={downloadSalaries}><FontAwesomeIcon icon={faDownload}/> Exporter les
                                salariés
                                (csv)
                            </button>
                            {/*
                      <button onClick={toggleSeances}>Afficher les séances</button>
                    */}



                            {/* caché pour le moment */}
                            <div style={{
                                display: "none",
                                flexDirection: "column",
                                outline: "1px solid var(--clr-accent)",
                                padding: "16px",
                                borderRadius: "16px"
                            }}>
                                <Formik initialValues={{file: null}} onSubmit={handleSubmitCsvUsersPrep}>
                                    {({setFieldValue}) => (
                                        <Form style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                                            <Field name="file">
                                                {({field}) => (
                                                    <input
                                                        type="file"
                                                        accept=".csv"
                                                        name="file"
                                                        onChange={(event) => {
                                                            setFieldValue("file", event.currentTarget.files[0]);
                                                        }}
                                                    />
                                                )}
                                            </Field>

                                            <button type="submit" className={styles.btnFileLogo}>Importer des salariés
                                                (csv)
                                            </button>
                                        </Form>
                                    )}
                                </Formik>

                                <div style={{ marginTop: "4px" }}>
                                    <button className={"btn"} onClick={generateCsv}
                                            style={{fontSize: "0.75em", padding: "5px", display: "flex", gap: "2px"}}
                                            title={"Télécharger le modèle d'importation des salariés (csv)"}>
                                        <FontAwesomeIcon icon={faDownload} style={{height: "16px"}}/> Modèle
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{marginBottom: "100px", position: "relative"}}>
                {afficherContrats &&
                    <ContratsTable contrats={contrats} putActifOpenModal={putActifOpenModalContrat}/>}
                {afficherSalaries &&
                    <UtilisateursTable utilisateurs={salaries} putActifOpenModal={putActifOpenModalUtilisateur}
                                       handleSubmitUtilisateurStatus={handleSubmitUtilisateurStatus}/>}
                {afficherReferents &&
                    <UtilisateursTable utilisateurs={referents} putActifOpenModal={putActifOpenModalUtilisateur}
                                       handleSubmitUtilisateurStatus={handleSubmitUtilisateurStatus}/>}
                {afficherSeances && <div>Séances à venir ... </div>}
            </div>
        </>
    )
}

export default EntrepriseVue;